import React from "react"
import Layout from "../layouts/zh"
import SEO from '../components/seo'

const IndexPage = (props) => (
  <Layout location={props.location}>
    <SEO title="院長的話" />

    <div className="container py-8 flex flex-col md:flex-row">
      <div className="w-2/3 md:w-1/4 md:mr-4 mb-8 md:mb-0">
        <img className="w-2/3 md:w-full mb-8" src="/AnnualReport2017-2018/images/principals-words/principal.jpg" alt="President" />
        <img className="w-2/3 mb-2" src="/AnnualReport2017-2018/images/principals-words/sign-zh.png" alt="President Sign" />
        <div className="mb-1">旅遊學院院長</div>
        <div className="text-2xl">黃竹君博士</div>
      </div>

      <div className="w-full md:w-3/4 md:ml-4">
        <h1 className="mb-2">院長的話</h1>
        <div className="text-3xl mb-4 md:mb-8">締造旅遊大時代領航者</div>

        <div className="font-normal content mb-8 text-left text-justify">
          <p>旅遊學院致力成為全球提供旅遊和服務業教育的優秀高等院校。卓越的教學能力、專業的學術團隊、國際化的學習環境、完善的專業設施，以至與澳門及世界各地業界的密切聯繫，令旅遊學院建立世界領先旅遊教育機構的聲望。 </p>
          <p>站在時代發展的新起點，旅遊學院繼續秉持創新的理念，銳意進取，與時俱進地推動學院發展。除了不斷提升日間學士學位課程的質量外，2016/17學年，學院推出了第三個夜間學士學位課程，教學團隊也正籌備推出首批研究生課程，為從業者和有意投身旅遊服務業的人士提供更多進修和增值的選擇。與此同時，學院氹仔校區的第二間教學酒店的籌備工作也有序推進，希望在增添校園資源，充實教學內容的同時，為推動學院長足發展邁出踏實的一步。</p>
          <p>2017年澳門獲評定為“聯合國教科文組織創意城市美食之都”，澳門藉此於2018年啟動“澳門美食年”，旅遊學院配合特區政府發展方針，在課程設計上進一步增加澳門土生菜元素及組織不同活動，以推廣和傳承澳門的獨特美食。</p>
          <p>旅遊學院現正積極加強與內地城市和海外教育機構合作，於2017/18年度與聯合國世界旅遊組織、緬甸聯邦共和國的旅遊部門、江門職業技術學院等合作，開展專業培訓課程，推動粵港澳大灣區以及“一帶一路”沿線國家和地區的旅遊人才培訓。學院亦與澳門特區政府旅遊局合作，培訓來自葡語系國家共74位官員，以及協助珠海及南沙培訓3,174名學生。同時，學院的世界旅遊教育及培訓中心與世界旅遊組織合作開展旅遊培訓工作，提升行業人力資源質素，助力旅遊業可持續發展。此外，隨著粵港澳大灣區發展規劃即將出台，澳門將致力打造成大灣區旅遊教育培訓基地，而旅遊學院將聯同澳門其他院校和相關部門，以及大灣區各城市的旅遊部門及機構，助力大灣區的旅遊發展和人才培養工作。</p>
          <p>旅遊行業在世界各地蓬勃發展，據世界經濟論壇發佈的《2017年旅遊業競爭力報告》顯示，目前全球旅遊業收入已佔全球國內生產總值的10%。亞洲成為全球入境人數增長最快的地區，旅遊業的“亞洲世紀”已悄然而至。旅遊學院作為澳門特別行政區政府旅遊發展委員會、文化產業委員會、人才發展委員會、公共服務評審委員會、會展業發展委員會、粵澳發展策略小組以及高等教育委員會等成員單位，長遠目標是繼續配合澳門特區政府和中央政府的策略，為推動澳門成為世界旅遊休閒中心作出貢獻。 </p>
          <p>旅遊學院立足澳門，放眼國際，通過持續提升教學和研究質量，加強學院在國際上的競爭力。致力不斷擴大與全球的教育機構、旅遊組織和研究機構的合作夥伴關係，拓展國際網絡。直至2017/18學年，已與全球31個國家及地區的104個機構合作，逾500個旅遊組織及機構可為學生提供實習機會。對豐富學生經驗、開拓國際化視野以及提高學院人才競爭力大有裨益。</p>
          <p>展望未來，旅遊學院將以更廣闊的視野，堅持提升辦學水平，營建一流的教研環境，塑造行業教育的標桿，為澳門以及全球的旅遊服務業培育領導者。</p>
        </div>

        <button type="button"
          onClick={() => {window.history.go(-1); return false}}
          className="py-3 px-8 font-semibold border-2 border-blue-500 text-blue-500 hover:text-white hover:bg-blue-500"
        >返回</button>
      </div>
    </div>
  </Layout>
)

export default IndexPage
